// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1ZE_z","infoBtn":"quickbooks_infoBtn__3vDeN","formBox":"quickbooks_formBox__3IzmB","formFooter":"quickbooks_formFooter__1nOex"};